import { Box, IconButton, Popover, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { saveCaption } from "../../../live-caption/functions";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../../../notifications";
import { IconClose } from "../../icons/svg";
import { isLocalParticipantModerator } from "../../participants";
import Tooltip from "../../tooltip/components/Tooltip";
import { ImageSaveCaption } from "./Icon";
import Icon from "../../icons/components/Icon";
import Button from "../../ui/components/web/Button";
import { BUTTON_TYPES } from "../../ui/constants.any";
import { setIsFirstSaveEnabled } from "../../../live-caption/slice";
import { checkOwnerCaption } from "../../util/functions";
const SaveCaptionPopover = () => {
    const { enabled } = useSelector((state) => state['features/live-caption']);
    const isLocalModerator = useSelector((state) => isLocalParticipantModerator(state));
    const _state = useSelector((state) => state);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const keyTrans = "popover.saveCaption";
    const [anchorEl, setAnchorEl] = useState(null);
    const [showSaveCaptionPopup, setShowSaveCaptionPopup] = useState(0);
    const open = Boolean(anchorEl) && showSaveCaptionPopup;
    const id = open ? 'save-caption-popover' : undefined;
    const handleClose = () => {
        setShowSaveCaptionPopup(-1);
        const highlightElm = document.querySelector('.toolbox-button-wth-dialog');
        if (highlightElm) {
            highlightElm.classList.remove('show-save-popover');
        }
    };
    const handleStartSaveCaption = () => {
        if (isLocalModerator) {
            let liveCaptionSaveStatus = 2;
            webSocket.emit("enable_save_live_caption_client", liveCaptionSaveStatus);
            webSocket.once("enable_save_live_caption_server", (data) => {
                if (data === 1) {
                    dispatch(showNotification({
                        titleKey: `${keyTrans}.startedSave`,
                    }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
                }
                else {
                    webSocket.emit("enable_save_live_caption_client", 1);
                    webSocket.emit("enable_live_caption_room_client", true);
                    dispatch(saveCaption(true));
                    checkOwnerCaption(dispatch, _state);
                }
                handleClose();
            });
        }
    };
    useEffect(() => {
        if (enabled && showSaveCaptionPopup === 0) {
            if (isLocalModerator) {
                let liveCaptionSaveStatus = 2;
                webSocket.emit("enable_save_live_caption_client", liveCaptionSaveStatus);
                webSocket.once("enable_save_live_caption_server", (data) => {
                    if (data !== 1) {
                        const elm = document.querySelector('[data-id="item-closed-caption"]');
                        const highlightElm = document.querySelector('.toolbox-button-wth-dialog');
                        if (highlightElm) {
                            highlightElm.classList.add('show-save-popover');
                        }
                        dispatch(setIsFirstSaveEnabled(true));
                        setAnchorEl(elm);
                        setShowSaveCaptionPopup(1);
                    }
                });
            }
        }
    }, [enabled]);
    return (React.createElement(Popover, { id: id, open: Boolean(anchorEl) && showSaveCaptionPopup === 1, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        } },
        React.createElement(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' },
            React.createElement(Tooltip, { content: t("dialog.close") },
                React.createElement(IconButton, { className: "close-popover", onClick: handleClose },
                    React.createElement(Icon, { src: IconClose, size: 24 }))),
            React.createElement(ImageSaveCaption, { style: { marginTop: '-8px' } }),
            React.createElement(Typography, { sx: { fontSize: '20px', fontWeight: 600, width: '100%' } }, t(`${keyTrans}.title`)),
            React.createElement(Typography, { sx: { fontSize: '15px', fontWeight: 500 } },
                t(`${keyTrans}.content`),
                " ",
                React.createElement("span", { style: { fontWeight: 700 } }, t(`${keyTrans}.feature`)))),
        React.createElement(Button, { type: BUTTON_TYPES.SECONDARY, onClick: handleStartSaveCaption, accessibilityLabel: t(`${keyTrans}.startSave`), labelKey: `${keyTrans}.startSave` })));
};
export default SaveCaptionPopover;
